import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import { orgId, Ajax } from 'utils';
import { selectCheckedShowIncidentSub } from 'state/selectors/subscriptionSelectors';
import * as actionTypes from '../actions/actionTypes';
import * as subscriptionActions from '../actions/groupMembershipActions';
import { encode64, formatFormData } from '../../utils/ebUtils';

export function* getGroupMembershipList() {
 try {
     yield put(subscriptionActions.getGroupMembershipList.pending({pending:"pending"}));
     const url = '/rest/incident/subscription/contactIdAndGroupIds';
     const result = yield call(Ajax.get, url);
     const { status, data } = result;
     const payload = {
       message: status,
       resultData: [...data?.data?.groupInfo??[]]
     };
     if (status === 200) {
       yield put(subscriptionActions.getGroupMembershipList.success(payload));
     } else {
       yield put(subscriptionActions.getGroupMembershipList.fail({
         status
       }));
     }
   } catch (error) {
     yield put(subscriptionActions.getGroupMembershipList.fail(error));
   }
}


export function* watchGroupMembershipList() {
  yield takeLatest(actionTypes.GET_GROUP_MEMBERSHIP.ACTION, getGroupMembershipList);
}
